import type { SVGProps } from 'react'

export const ReportsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.66675 1.5H18.3334M17.5001 1.5V10.6667C17.5001 11.1087 17.3245 11.5326 17.0119 11.8452C16.6994 12.1577 16.2754 12.3333 15.8334 12.3333H4.16675C3.72472 12.3333 3.3008 12.1577 2.98824 11.8452C2.67568 11.5326 2.50008 11.1087 2.50008 10.6667V1.5M5.83341 16.5L10.0001 12.3333L14.1667 16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
